var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRefresh = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 7 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m22.231 8.244-1.359 1.36a4 4 0 0 0-.226-.25A8 8 0 0 0 15 7c-4.411 0-8 3.589-8 8s3.589 8 8 8a7.946 7.946 0 0 0 7.668-5.715 1 1 0 1 0-1.916-.57A5.96 5.96 0 0 1 15 21c-3.309 0-6-2.691-6-6s2.691-6 6-6c1.599 0 3.115.65 4.236 1.765l.204.271-2.195 2.195c-.425.425-.283.769.318.769h4.893a.543.543 0 0 0 .544-.544V8.563c0-.601-.344-.743-.769-.319"
})));
export default SvgRefresh;